function setEndOfDayBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(23);
    modDate.setMinutes(59);
    modDate.setSeconds(59);
    modDate.setMilliseconds(999);

    return modDate.toISOString().replace('Z', '');
}

function setStartOfDayToBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(0);
    modDate.setMinutes(0);
    modDate.setSeconds(0);
    modDate.setMilliseconds(0);

    return modDate.toISOString().replace('Z', '');
}

export const DateHelper = {
    setEndOfDayBackendString,
    setStartOfDayToBackendString,
};
